<template>
  <div>

    <div id="basic-non-sticky-notification-packet-success" class="toastify-content hidden flex flex-col sm:flex-row">
      <div class="font-medium text-primary-4" v-if="page_data.message">{{ page_data.message }}</div>
    </div>
    <div id="basic-non-sticky-notification-packet" class="toastify-content hidden flex flex-col sm:flex-row">
      <div class="font-medium text-primary-3" v-if="page_data.error">{{ page_data.error }}</div>
    </div>

    <div id="new-manual-planning" ref="new-manual-planning" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Add Planning Details</h2>
          </div>
          <div class="modal-body">

            <div class="w-full max-w-full overflow-x-auto relative">

              <table class="min-w-[100px] w-full border border-gray-200 text-sm">
                <!-- ================= HEADER ================= -->
                <thead class="bg-slate-100 sticky top-0 z-10">
                  <tr class="text-center">
                    <th rowspan="2" class="th">#</th>

                    <th colspan="2" class="th-group">Weight</th>
                    <th colspan="8" class="th-group">Quality</th>
                    <th colspan="3" class="th-group">Property</th>
                    <th colspan="4" class="th-group">Pricing</th>
                    <th colspan="2" class="th-group">Lab</th>
                    <th colspan="1" class="th-group">Final Pricing</th>

                    <th rowspan="2" class="th">Action</th>
                  </tr>

                  <tr class="bg-slate-50 text-xs">
                    <th class="th">Mk Wt</th>
                    <th class="th">PL Wt</th>

                    <th class="th">Shp</th>
                    <th class="th">Color</th>
                    <th class="th">Purity</th>
                    <th class="th">Cut</th>
                    <th class="th">Polish</th>
                    <th class="th">Symm</th>
                    <th class="th">Fluc</th>
                    <th class="th">Tension</th>

                    <th class="th">Ratio</th>
                    <th class="th">Table</th>
                    <th class="th">Height</th>

                    <th class="th">R Rate</th>
                    <th class="th">Back %</th>
                    <th class="th">Per/Ct $</th>
                    <th class="th">Total $</th>

                    <th class="th">Lab</th>
                    <th class="th">Rate</th>
                    <th class="th">Amount</th>
                  </tr>
                </thead>

                <!-- ================= BODY ================= -->
                <tbody>
                  <tr class="hover:bg-gray-50 text-center">
                    <td class="td"></td>

                    <td class="td"><input v-model="page_data.bulkPlanning.weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                        @change="onBulkValueChange('weight')" /></td>
                    <td class="td"><input v-model="page_data.bulkPlanning.polish_weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                        @change="onBulkValueChange('polish_weight')" /></td>

                    <td class="td"><select v-model="page_data.bulkPlanning.shape" class="select" @change="onBulkValueChange('shape')">
                        <option v-for="(s, i) in diamond.shapes" :key="i" :value="s.id">{{ s.shape_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.color" class="select-60px" @change="onBulkValueChange('color')">
                        <option v-for="(c, i) in diamond.colors" :key="i" :value="c.id">{{ c.color_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.purity" class="select-60px" @change="onBulkValueChange('purity')">
                        <option v-for="(p, i) in diamond.purities" :key="i" :value="p.id">{{ p.purity_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.cut" class="select-60px" @change="onBulkValueChange('cut')">
                        <option v-for="(c, i) in diamond.cuts" :key="i" :value="c.id">{{ c.cut_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.polish" class="select-60px" @change="onBulkValueChange('polish')">
                        <option v-for="(p, i) in diamond.polish" :key="i" :value="p.id">{{ p.polish_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.symmetry" class="select-60px" @change="onBulkValueChange('symmetry')">
                        <option v-for="(s, i) in diamond.symmetry" :key="i" :value="s.id">{{ s.symmetry_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.fluerocent" class="select-60px" @change="onBulkValueChange('fluerocent')">
                        <option v-for="(s, i) in diamond.fluerocents" :key="i" :value="s.id">{{ s.fluerocent_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.tension" class="select-60px" @change="onBulkValueChange('tension')">
                        <option v-for="(s, i) in diamond.tensions" :key="i" :value="s.id">{{ s.tension_name }}</option>
                      </select></td>

                    <td class="td"><select v-model="page_data.bulkPlanning.ratio" class="select-60px" @change="onBulkValueChange('ratio')">
                        <option v-for="(r, i) in diamond.ratios" :key="i" :value="r.id">{{ r.ratio_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.tabl" class="select-60px" @change="onBulkValueChange('tabl')">
                        <option v-for="(t, i) in diamond.tabls" :key="i" :value="t.id">{{ t.tabl_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="page_data.bulkPlanning.height" class="select-60px" @change="onBulkValueChange('height')">
                        <option v-for="(h, i) in diamond.heights" :key="i" :value="h.id">{{ h.height_name }}</option>
                      </select></td>

                    <td class="td"></td>
                    <td class="td"><input v-model="page_data.bulkPlanning.discount" class="input-50px"
                        @change="onBulkValueChange('discount')" /></td>
                    <td class="td"><input v-model="page_data.bulkPlanning.value" class="input-70px"
                        @change="onBulkValueChange('value')" /></td>
                    <td class="td"></td>

                    <td class="td"><select v-model="page_data.bulkPlanning.lab" class="select-small"  @change="onBulkValueChange('lab')">
                        <option v-for="(l, i) in diamond.labs" :key="i" :value="l.id">{{ l.lab_name }}</option>
                      </select></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td">
                      <button @click="reset_group()" class="text-red-600 hover:text-red-800">
                        <RefreshCcwIcon class="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                  <tr v-for="(plan, index) in page_data.manualPlanning" :key="index" class="hover:bg-gray-50 text-center">
                    <td class="td">{{ index + 1 }}</td>

                    <td class="td"><input v-model="plan.weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                        @change="onPlanValueChange(plan, 'weight', true)" /></td>
                    <td class="td"><input v-model="plan.polish_weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                        @change="onPlanValueChange(plan, 'polish_weight', true)" /></td>

                    <td class="td"><select v-model="plan.shape" class="select"  :title="getShapeName(plan.shape)"  @change="onPlanValueChange(plan, 'shape', true)">
                        <option v-for="(s, i) in diamond.shapes" :key="i" :value="s.id">{{ s.shape_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.color" class="select-60px"  @change="onPlanValueChange(plan, 'color', true)">
                        <option v-for="(c, i) in diamond.colors" :key="i" :value="c.id">{{ c.color_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.purity" class="select-60px" @change="onPlanValueChange(plan, 'purity', true)">
                        <option v-for="(p, i) in diamond.purities" :key="i" :value="p.id">{{ p.purity_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.cut" class="select-60px" @change="onPlanValueChange(plan, 'cut', true)">
                        <option v-for="(c, i) in diamond.cuts" :key="i" :value="c.id">{{ c.cut_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.polish" class="select-60px" @change="onPlanValueChange(plan, 'polish', true)">
                        <option v-for="(p, i) in diamond.polish" :key="i" :value="p.id">{{ p.polish_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.symmetry" class="select-60px" @change="onPlanValueChange(plan, 'symmetry', true)">
                        <option v-for="(s, i) in diamond.symmetry" :key="i" :value="s.id">{{ s.symmetry_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.fluerocent" class="select-60px" @change="onPlanValueChange(plan, 'fluerocent', true)">
                        <option v-for="(s, i) in diamond.fluerocents" :key="i" :value="s.id">{{ s.fluerocent_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.tension" class="select-60px" @change="onPlanValueChange(plan, 'tension', true)">
                        <option v-for="(s, i) in diamond.tensions" :key="i" :value="s.id">{{ s.tension_name }}</option>
                      </select></td>

                    <td class="td"><select v-model="plan.ratio" class="select-60px" @change="onPlanValueChange(plan, 'ratio', true)">
                        <option v-for="(r, i) in diamond.ratios" :key="i" :value="r.id">{{ r.ratio_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.tabl" class="select-60px" @change="onPlanValueChange(plan, 'tabl', true)">
                        <option v-for="(t, i) in diamond.tabls" :key="i" :value="t.id">{{ t.tabl_name }}</option>
                      </select></td>
                    <td class="td"><select v-model="plan.height" class="select-60px" @change="onPlanValueChange(plan, 'height', true)">
                        <option v-for="(h, i) in diamond.heights" :key="i" :value="h.id">{{ h.height_name }}</option>
                      </select></td>

                    <td class="td"><input v-model="plan.r_rate" disabled class="input-80px bg-gray-100" /></td>
                    <td class="td"><input v-model="plan.discount" class="input-50px"
                    :disabled="settings && settings['ADD_PLAN_BACK'] && (settings['ADD_PLAN_BACK'] == 1)"
                        @change="onPlanValueChange(plan, 'discount', true)" /></td>
                    <td class="td"><input v-model="plan.value" class="input-70px"
                        @change="onPlanValueChange(plan, 'value', true)" /></td>
                    <td class="td"><input v-model="plan.total_value" disabled class="input-70px bg-gray-100" /></td>

                    <td class="td"><select v-model="plan.lab" class="select-60px"  @change="onPlanValueChange(plan, 'lab', true)">
                        <option v-for="(l, i) in diamond.labs" :key="i" :value="l.id">{{ l.lab_name }}</option>
                      </select></td>
                    <td class="td"><input v-model="plan.lab_rate" disabled class="input-70px bg-gray-100" /></td>
                    <td class="td"><input v-model="plan.total_amount" disabled class="input-70px bg-gray-100" /></td>

                    <td class="td">
                      <button @click="removeField(plan.id)" class="text-red-600 hover:text-red-800">
                        <Trash2Icon class="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-50 text-center">
                    <td class="td"></td>

                    <td class="td">{{ page_data.menual_total.weight }}</td>
                    <td class="td">{{ page_data.menual_total.polish_weight }}</td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td"></td>

                    <td class="td">{{ page_data.menual_total.value }}</td>
                    <td class="td">{{ page_data.menual_total.total_value }}</td>
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td">{{ page_data.menual_total.total_amount }}</td>

                    <td class="td">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer flex justify-between items-center">
            <div>
              <button type="button" @click="AddFieldPlan" class="btn btn-primary btn-sm mr-auto">
                New Part Planning
              </button>

            </div>
            <div>

              <button type="button" data-dismiss="modal" class="btn btn-outline-secondary  btn-sm mr-1">
                Cancel
              </button>
              <button type="button" @click="submitManualPlanning" :disabled="page_data.loading"
                class="btn btn-primary  btn-sm">Save
                Details
                <LoadingIcon v-if="page_data.loading" icon="oval" color="white" class="w-4 h-4 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script setup>
import { BASE_URL } from "@/constants/config";
import store from "@/store";
import { inject, reactive, computed } from "vue";
import Toastify from 'toastify-js'

const swal = inject('$swal')
const emit = defineEmits(['initTabulator', 'getPacketPlans'])

const user_details = computed(() => store.state.user.currentUser)

const settings = computed(() => store.state.user.settings)

const page_data = reactive({
  loading: false,
  stone: '',
  pack_id: '',
  plan_id: '',
  account_id: user_details.value.account_id,
  pack_weight: '',
  menual_total: {
    weight: 0,
    polish_weight: 0,
    value: 0,
    total_value: 0,
    total_amount: 0,
  },
  total_items: 1,
  message: "",
  error: "",
  manualPlanning: [{
    id: 1,
    part_no: '',
    weight: '',
    polish_weight: '',
    color: '',
    cut: '',
    purity: '',
    polish: '',
    shape: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    stone: '',
    ratio: '',
    tabl: '',
    r_rate: '',
    value: '',
    height: '',
    discount: '',
    total_value: '',
    lab: '',
    lab_rate: '',
    total_amount: '',
  }],
  bulkPlanning: {
    weight: '',
    polish_weight: '',
    color: '',
    cut: '',
    purity: '',
    polish: '',
    shape: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    ratio: '',
    tabl: '',
    height: '',
    value: '',
    discount: '',
    lab: '',
    lab_rate: ''
  },

  default_lab: ""

})

const diamond = reactive({
  colors: [],
  cuts: [],
  purities: [],
  symmetry: [],
  polish: [],
  fluerocents: [],
  tensions: [],
  stones: [],
  shapes: [],
  heights: [],
  ratios: [],
  tabls: [],
  labs: [],
})

const removeField = (id) => {
  swal({
    title: "Are you sure?",
    text: "You are about to delete a item!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Delete",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      var i = page_data.manualPlanning.length;
      while (i--) {
        if (page_data.manualPlanning[i]['id'] == id) {
          page_data.manualPlanning.splice(i, 1);
        }
      }
    }
  });
}

const AddFieldPlan = () => {
  page_data.total_items++
  page_data.manualPlanning.push(
    {
      id: page_data.total_items,
      part_no: '',
      weight: page_data.bulkPlanning.weight,
      polish_weight: page_data.bulkPlanning.polish_weight,
      color: page_data.bulkPlanning.color,
      cut: page_data.bulkPlanning.cut,
      purity: page_data.bulkPlanning.purity,
      polish: page_data.bulkPlanning.polish,
      shape: page_data.bulkPlanning.shape,
      symmetry: page_data.bulkPlanning.symmetry,
      fluerocent: page_data.bulkPlanning.fluerocent,
      tension: page_data.bulkPlanning.tension,
      stone: page_data.stone,
      ratio: page_data.bulkPlanning.ratio,
      tabl: page_data.bulkPlanning.tabl,
      r_rate: page_data.bulkPlanning.r_rate,
      value: page_data.bulkPlanning.value,
      height: page_data.bulkPlanning.height,
      discount: page_data.bulkPlanning.discount,
      total_value: '',
      lab: page_data.bulkPlanning.lab,
      lab_rate: '',
      total_amount: '',
    }
  );

  onPlanValueChange(page_data.manualPlanning[page_data.manualPlanning.length - 1], 'polish_weight', false);

}

const reset_group = () => {
  Object.assign(page_data.bulkPlanning, {
    weight: '',
    polish_weight: '',
    color: '',
    cut: '',
    purity: '',
    polish: '',
    shape: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    ratio: '',
    tabl: '',
    height: '',
    value: '',
    discount: '',
    lab: page_data.default_lab,
    lab_rate: ''
  })
}


function submitManualPlanning() {

  let submit = true
  page_data.manualPlanning.forEach(plan => {
    if (plan.weight == '' || plan.polish_weight == '' || plan.color == '' || plan.cut == '' || plan.purity == '' || plan.polish == '' || plan.shape == '' || plan.symmetry == '' || plan.fluerocent == '' || plan.height == '' || plan.ratio == '' || plan.tabl == '') {
      swal("Warning!", "Fileds are Empty !", "warning")
      submit = false
    }
  });

  if (submit == true) {

    page_data.loading = true
    let params = {
      plan_details: page_data.manualPlanning,
      packet_id: page_data.pack_id,
      plan_id: page_data.plan_id,
      account_id: page_data.account_id,
      menual_total: page_data.menual_total,
    }

    axios({
      url: 'api/plan/add_plan_values',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      config: { headers: { 'Accept': 'application/json' } }
    }).then((res) => {

      cash('#new-manual-planning').modal('hide')
      page_data.manualPlanning = [{
        id: 1,
        part_no: '',
        weight: '',
        polish_weight: '',
        color: '',
        cut: '',
        purity: '',
        polish: '',
        shape: '',
        symmetry: '',
        fluerocent: '',
        tension: '',
        stone: '',
        ratio: '',
        tabl: '',
        r_rate: '',
        value: '',
        height: '',
        discount: '',
        total_value: '',
        lab: page_data.default_lab,
        lab_rate: '',
        total_amount: '',
      }]

      reset_group();
      emit('getPacketPlans', page_data.pack_id)
      page_data.total_items = 1
      page_data.pack_id = ''
      page_data.pack_weight = ''
      page_data.plan_id = ''

      page_data.message = res.data.success

      page_data.menual_total.polish_weight = 0
      page_data.menual_total.weight = 0
      page_data.menual_total.value = 0
      page_data.menual_total.total_value = 0
      page_data.menual_total.total_amount = 0

      setTimeout(() => {
        basicNonStickyNotificationPacketSuccess()
      }, 100)
      setTimeout(() => {
        page_data.message = ''
      }, 3000);
      page_data.loading = false
      emit('initTabulator')
    }).catch((err) => {
      page_data.error = err.response.data.error
      page_data.loading = false
      setTimeout(() => {
        basicNonStickyNotificationPacket()
      }, 100)
      setTimeout(() => {
        page_data.error = ''
      }, 3000);
    })
  }

}

const onPlanValueChange = async (plan, type, resetGroup) => {

  if(resetGroup == true) {
    page_data.bulkPlanning[type] = ''
  }
  const toNum = (val) => parseFloat(val) || 0;

  const calculateValueFromDiscount = () => {
    const rate = toNum(plan.r_rate);
    const discount = toNum(plan.discount);
    plan.value = (rate + (rate * discount) / 100).toFixed(2);
  };

  const calculateDiscountFromValue = () => {
    const rate = toNum(plan.r_rate);
    const value = toNum(plan.value);
    plan.discount = rate ? ((value - rate) * 100) / rate : 0;
  };

  const checkPackLimit = async (field) => {
    await getPlanningTotal();

    if (
      toNum(page_data.menual_total?.[field]) >
      toNum(page_data.pack_weight)
    ) {
      swal("Warning!", "Total Planning Weight Must Be less then Issue Weight!", "warning")
      plan[field] = "";
      return false;
    }
    return true;
  };

  const updateRepoRateAndValue = async () => {
    const repo = await getRepoValue(plan);
    plan.r_rate = repo?.r_rate || 0;

    if(settings.value && settings.value['ADD_PLAN_BACK']) {

      console.log(settings.value)
      if(settings.value['ADD_PLAN_BACK'] == 1 || settings.value['ADD_PLAN_BACK'] == 3) {
        console.log(settings.value['ADD_PLAN_BACK'])
        plan.discount = repo?.back || 0;
      }
    }
    calculateValueFromDiscount();
  };

  const updateLabValue = async () => {
    const value = await getLabValue(plan);
    plan.lab_rate = value?.rate || 0;
  };

  switch (type) {
    case "weight":
      if (plan.weight !== "") {
        await checkPackLimit("weight");
      }
      break;

    case "polish_weight":
      if (plan.polish_weight !== "") {
        const isValid = await checkPackLimit("polish_weight");

        if (isValid) {
          await updateRepoRateAndValue();
          await updateLabValue();
        }
      } else {
        plan.r_rate = "";
        plan.value = "";
      }
      break;

    case "discount":
      calculateValueFromDiscount();
      break;

    case "value":
      calculateDiscountFromValue();
      break;

    case "lab":
      // 🔥 If lab affects repo value later
      await updateLabValue();
      break;

    case "shape":
    case "color":
    case "purity":
    case "cut":
    case "polish":
    case "symmetry":
    case "fluerocent":
    case "tension":
    case "ratio":
    case "tabl":
    case "height":
      await updateRepoRateAndValue();
      break;
  }

  plan.total_value = (toNum(plan.value) * toNum(plan.polish_weight)).toFixed(2);
  plan.total_amount = (toNum(plan.total_value) + toNum(plan.lab_rate)).toFixed(2);

  getPlanningTotal();
};


const onBulkValueChange = async (type) => {


  for(let i = 0; i < page_data.manualPlanning.length; i++){

    let plan = page_data.manualPlanning[i]

    plan[type] = page_data.bulkPlanning[type]

    if(['shape', 'weight', 'polish_weight', 'color', 'purity', 'lab', 'discount', 'value'].includes(type)){
      onPlanValueChange(plan, type, false)
    }
  }
};


const getRepoValue = async (plan) => {
  try {
    // Required fields check
    if (
      !plan.shape ||
      !plan.color ||
      !plan.purity ||
      !plan.polish_weight
    ) {
      return { r_rate: 0 };
    }

    // Get shape group
    const shapeObj = diamond.shapes.find(
      (s) => s.id == plan.shape
    );

    const params = {
      color: plan.color,
      cut: plan.cut,
      purity: plan.purity,
      polish: plan.polish,
      symmetry: plan.symmetry,
      fluerocent: plan.fluerocent,
      tension: plan.tension,
      height: plan.height,
      ratio: plan.ratio,
      tabl: plan.tabl,
      shape: plan.shape,
      shape_group: shapeObj?.shape_group || "",
      polish_weight: plan.polish_weight,
      stone: page_data.stone,
    };

    const res = await axios({
      url: "api/plan/get_plan_values",
      method: "post",
      baseURL: BASE_URL,
      data: params,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    return {
      r_rate: res?.data?.rape_value || 0,
      back: res?.data?.back || 0,
    };
  } catch (error) {
    console.error("Repo value API error:", error);
    return { r_rate: 0 };
  }
};

const getLabValue = async (plan) => {
  try {
    // Required fields check
    if (
      !plan.lab ||
      !plan.polish_weight
    ) {
      return { rate: 0 };
    }

    const params = {
      lab_id: plan.lab,
      polish_weight: plan.polish_weight,
    };

    const res = await axios({
      url: "api/plan/get_lab_values",
      method: "post",
      baseURL: BASE_URL,
      data: params,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    return {
      rate: res?.data?.value || 0,
    };
  } catch (error) {
    console.error("Repo value API error:", error);
    return { rate: 0 };
  }
};

const addNewPlanning = (item) => {
  page_data.stone = item.stone
  page_data.pack_weight = item.cr_weight

  getDiamontData();

  page_data.manualPlanning = [{
    id: 1,
    part_no: '',
    weight: '',
    polish_weight: '',
    color: '',
    cut: '',
    purity: '',
    polish: '',
    shape: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    stone: page_data.stone,
    ratio: '',
    tabl: '',
    r_rate: '',
    value: '',
    height: '',
    discount: '',
    total_value: '',
    lab: page_data.default_lab,
    lab_rate: '',
    total_amount: '',
  }]

  reset_group()

  getPlanningTotal()

  page_data.pack_id = item.id
  page_data.total_items = 1

  cash('#new-manual-planning').modal('show')
}

function getPlanningTotal() {
  let length = page_data.manualPlanning.length

  page_data.menual_total.weight = 0
  page_data.menual_total.polish_weight = 0
  page_data.menual_total.total_value = 0
  page_data.menual_total.total_amount = 0

  for (let i = 0; i < length; i++) {
    page_data.menual_total.weight = parseFloat(parseFloat(page_data.menual_total.weight) + parseFloat(page_data.manualPlanning[i]['weight'] ? page_data.manualPlanning[i]['weight'] : 0)).toFixed(4)
    page_data.menual_total.polish_weight = parseFloat(parseFloat(page_data.menual_total.polish_weight) + parseFloat(page_data.manualPlanning[i]['polish_weight'] ? page_data.manualPlanning[i]['polish_weight'] : 0)).toFixed(4)
    page_data.menual_total.total_value = parseFloat(parseFloat(page_data.menual_total.total_value) + parseFloat(page_data.manualPlanning[i]['total_value'] ? page_data.manualPlanning[i]['total_value'] : 0))
    page_data.menual_total.total_amount = parseFloat(parseFloat(page_data.menual_total.total_amount) + parseFloat(page_data.manualPlanning[i]['total_amount'] ? page_data.manualPlanning[i]['total_amount'] : 0))
  }
}

function updatePlanDetails(data) {

  page_data.pack_id = data.pack_id
  page_data.plan_id = data.id
  page_data.pack_weight = data.weight
  page_data.stone = data.stone

  let params = {
    packet_id: window.btoa(page_data.pack_id),
    plan_id: window.btoa(page_data.plan_id)
  }
  axios({
    url: 'api/plan/single_plan_packet_detail',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    config: { headers: { 'Accept': 'application/json' } }
  }).then((res) => {
    page_data.manualPlanning = res.data.items
    page_data.total_items = page_data.manualPlanning.length
    getPlanningTotal()
    getDiamontData()
    cash('#new-manual-planning').modal('show')
  })

}

const basicNonStickyNotificationPacket = () => {
  Toastify({
    node: cash('#basic-non-sticky-notification-packet')
      .clone()
      .removeClass('hidden')[0],
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'top',
    position: 'right',
    stopOnFocus: true
  }).showToast()
}
const basicNonStickyNotificationPacketSuccess = () => {
  Toastify({
    node: cash('#basic-non-sticky-notification-packet-success')
      .clone()
      .removeClass('hidden')[0],
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'top',
    position: 'right',
    stopOnFocus: true
  }).showToast()
}

const getDiamontData = async () => {
  try {
    const res = await axios({
      url: "api/master/get_all_parameters",
      method: "post",
      baseURL: BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    const data = res?.data || {};

    diamond.colors = data.color || [];
    diamond.cuts = data.cut || [];
    diamond.purities = data.purity || [];
    diamond.polish = data.polish || [];
    diamond.shapes = data.shape || [];
    diamond.symmetry = data.symmetry || [];
    diamond.fluerocents = data.fluerocent || [];
    diamond.tensions = data.tension || [];
    diamond.stones = data.stone || [];
    diamond.heights = data.height || [];
    diamond.tabls = data.tabl || [];
    diamond.ratios = data.ratio || [];
    diamond.labs = data.lab || [];

    // Add Empty Object for default lab
    diamond.labs.unshift({
      id: "",
      lab_name: "None",
      default: false,
    })
    // -----------------------------
    // Set Default Lab
    // -----------------------------
    const defaultLab = diamond.labs.find(
      (item) => item.default == 1
    );

    if (defaultLab) {
      page_data.default_lab = defaultLab.id;
      page_data.bulkPlanning.lab = defaultLab.id;
    }

    console.log(page_data.default_lab)

    // -----------------------------
    // Apply default lab to plans
    // -----------------------------
    if (!page_data.plan_id) {
      page_data.manualPlanning?.forEach((plan) => {
        plan.lab = page_data.default_lab;
      });
    }

  } catch (error) {
    console.error("Diamond master data API error:", error);
  }
};

const getShapeName = (id) => {
    return diamond.shapes.find(s => s.id === id)?.shape_name || '';
  }


defineExpose({
  addNewPlanning,
  updatePlanDetails
})
</script>
<style scoped>
.th {
  border: 1px solid #d1d5db;
  padding: 6px 0px;
  font-size: 12px;
  font-weight: 600;
  background: #f1f5f9;
  white-space: nowrap;
}

.th-group {
  border: 1px solid #d1d5db;
  padding: 6px 0px;
  font-size: 12px;
  font-weight: 700;
  background: #e2e8f0;
  text-align: center;
}

.td {
  border: 1px solid #d1d5db;
  padding: 4px;
  white-space: nowrap;
}

.input {
  width: 100px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-sm {
  width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-80px {
  width: 80px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-70px {
  width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-60px {
  width: 60px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-50px {
  width: 50px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}

.select {
  width: 90px;              /* FIXED WIDTH */
  max-width: 90px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-80px {
  width: 80px;              /* FIXED WIDTH */
  max-width: 80px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-70px {
  width: 70px;              /* FIXED WIDTH */
  max-width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-60px {
  width: 60px;              /* FIXED WIDTH */
  max-width: 60px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-50px {
  width: 50px;              /* FIXED WIDTH */
  max-width: 50px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
